import { client } from '../client'

export interface ReleaseNote {
  id: number
  documentId: string
  createdAt: string
  updatedAt: string
  publishedAt: string
  Title: string
  Body: string
  Version: string
  Description: string
  ReleaseDate: string
}

export interface ReleaseNotesResponse {
  data: ReleaseNote[]
  meta: {
    pagination: {
      page: number
      pageSize: number
      pageCount: number
      total: number
    }
  }
}

export const getReleaseNotesOptions = () => ({
  queryKey: ['release-notes'] as const,
  queryFn: async (): Promise<ReleaseNotesResponse> => {
    return client.request<ReleaseNotesResponse>('/api/release-notes')
  },
})
